"use client";

import { Download, ClipboardList, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";
import { HOW_IT_WORKS } from "@/lib/constants";
import { AnimateOnScroll } from "@/components/shared/AnimateOnScroll";
import {
  StaggerContainer,
  StaggerItem,
} from "@/components/shared/StaggerContainer";

const ICONS = [Download, ClipboardList, TrendingUp];

export function HowItWorks() {
  return (
    <section className="relative overflow-hidden pb-20 pt-6 sm:pb-28 sm:pt-10">
      {/* Soft gradient background */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-primary/[0.03] via-primary/[0.02] to-transparent" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <AnimateOnScroll>
          <h2 className="text-center text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Get started in minutes
          </h2>
        </AnimateOnScroll>

        <StaggerContainer
          className="mt-16 grid gap-6 sm:grid-cols-3 sm:gap-8"
          stagger={0.15}
        >
          {HOW_IT_WORKS.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <StaggerItem key={step.step} className="h-full">
                <motion.div
                  whileHover={{ y: -4 }}
                  transition={{ duration: 0.2 }}
                  className="flex h-full flex-col items-center rounded-2xl border border-border/50 bg-card p-8 text-center shadow-[var(--shadow-sm)] transition-shadow duration-300 hover:shadow-[var(--shadow-md)]"
                >
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/15 to-primary/5 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="mt-4 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                    {step.step}
                  </div>
                  <h3 className="mt-3 text-xl font-bold text-foreground">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-base text-muted-foreground">
                    {step.description}
                  </p>
                </motion.div>
              </StaggerItem>
            );
          })}
        </StaggerContainer>
      </div>
    </section>
  );
}
